<template>
    <v-card class="patient fill-height">
        <v-card-title primary-title>
            <v-icon v-if="locked == 'null'" @click="back" class="icon-back">
                keyboard_arrow_left
            </v-icon>
            <div>
                <div class="headline">{{ selectedPatient.lastname + " " + selectedPatient.firstname }}</div>
                <div>{{ this.getText(selectedPatient.gender) }} - {{ selectedPatient.birth_date | shortDate }} ({{
                    this.age }} ans) <strong v-if="selectedPatient.declined_study"> - Ne participe pas à l'étude</strong>
                </div>
                <div v-if="!selectedPatient.decline_data_collection">Accepte la récolte de donnée</div>
                <div v-if="selectedPatient.decline_data_collection">N'a pas accepté la récolte de donnée</div>
                <div v-if="selectedPatient.opale_number"><b>Numéro Opale :</b> {{ selectedPatient.opale_number }}</div>
            </div>
            <!--<v-spacer></v-spacer>-->
            <v-spacer></v-spacer>
            <patient-general-infos-modal v-if="$route.name === 'patient.view' || $route.name === 'patient.viewMedicalCase' || $route.name === 'patient.viewTreatment'"></patient-general-infos-modal>
            <!--<v-btn
                v-if="$route.name === 'patient.view' || $route.name === 'patient.viewMedicalCase' || $route.name === 'patient.viewTreatment'"
                flat @click="dialog_patient = true" color="primary">
                <v-icon>mdi-clipboard-account</v-icon> Info patient
            </v-btn>-->

            <v-btn v-if="$route.name === 'patient.view'" flat @click="dialog = true">
                <v-icon>edit</v-icon>
            </v-btn>
            <v-btn v-if="$route.name === 'patient.view'" flat @click="deleteDialog = true">
                <v-icon>delete</v-icon>
            </v-btn>
            <treatment-close-form v-if="$route.name === 'patient.viewTreatment' && selectedTreatment.open"></treatment-close-form>
            <case-close-form v-if="$route.name === 'patient.viewMedicalCase' && selectedMedicalCase.open"></case-close-form>
            <!--<v-btn v-if="$route.name === 'patient.viewTreatment'" @click="dialog_treatment = true" color="primary">Fermer
                le traitement
            </v-btn>-->
        </v-card-title>

        <v-alert  v-if="$route.name === 'patient.viewMedicalCase' && selectedMedicalCase.open == false" class="mb-0"
                  :value="true"
                  color="warning">
            <v-tooltip v-if="selectedMedicalCase.remarks" bottom>
                <template v-slot:activator="{ on }">
                    <v-icon dark v-on="on">info</v-icon>
                </template>
                <span>{{ selectedMedicalCase.remarks}}</span>
            </v-tooltip>
            Cas fermé le : {{ selectedMedicalCase.updated_at | shortDate }}
        </v-alert>

        <v-alert  v-if="$route.name === 'patient.viewTreatment' && selectedTreatment.open == false && selectedTreatment.closing_reason !== 'PAUSED'" class="mb-0"
                  :value="true"
                  color="warning">
            <v-tooltip v-if="selectedTreatment.closing_reason" bottom>
                <template v-slot:activator="{ on }">
                    <v-icon dark v-on="on">info</v-icon>
                </template>
                <span v-if="selectedTreatment.closing_reason !== 'OTHER'">
                    {{ getText(selectedTreatment.closing_reason) }}
                </span>
                <span>{{ selectedTreatment.remarks}}</span>
            </v-tooltip>
            Traitement fermé le : {{ selectedTreatment.updated_at | shortDate }}
        </v-alert>
        <v-alert  v-else-if="$route.name === 'patient.viewTreatment' && selectedTreatment.open == false  && selectedTreatment.closing_reason === 'PAUSED'" class="mb-0 py-0"
                  :value="true"
                  color="info">
            <v-layout row justify-space-between align-center>
                <div class="flex-grow-1">Traitement en pause</div>
                <treatment-resume-form></treatment-resume-form>
            </v-layout>

        </v-alert>

        <v-divider></v-divider>

        <router-view></router-view>
        <v-dialog v-model="dialog" persistent max-width="480">
            <v-card>
                <v-card-title class="headline">Modifier le patient</v-card-title>
                <v-card-text>Voulez-vous vérouiller la tablette et activer la saisie patient ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="editPatient(false)">Non, continuer</v-btn>
                    <v-btn color="primary" text @click="editPatient(true)">Oui, verrouiller</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteDialog" persistent max-width="480">
            <v-card>
                <v-card-title class="headline">Supprimer le patient</v-card-title>
                <v-card-text>Voulez-vous vraiment supprimer le patient ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="deleteDialog = false">Annuler</v-btn>
                    <v-btn color="primary" text @click="deletePatient()">Oui, supprimer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmDialog" persistent max-width="480">
            <v-card>
                <v-card-title class="headline">
                    Supprimer le patient
                </v-card-title>
                <v-card-text class="lock-screen">
                    <v-form v-if="nb_try < 3" ref="form" lazy-validation>
                        <v-container grid-list-md text-xs-center>
                            <v-layout row wrap align-center>
                                <v-flex offset-xs4 xs1>
                                    <v-card dark color="secondary">
                                        <v-card-text class="px-0">
                                            <input @keyup="updateInput($event, 'input2')" maxlength="1"
                                                   v-model="input1" ref="input1" @focusin="input1 = ''"
                                                   type="text" pattern="[0-9]*" inputmode="numeric"
                                                   min="0" max="9"
                                                   required autofocus>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs1>
                                    <v-card dark color="secondary">
                                        <v-card-text class="px-0">
                                            <input @keyup="updateInput($event, 'input3')" maxlength="1"
                                                   v-model="input2" ref="input2"
                                                   type="text" pattern="[0-9]*" inputmode="numeric"
                                                   min="0" max="9"
                                                   @focusin="input2 = ''; input1 === '' ? moveInputToPrevious('input1') : null"
                                            >
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs1>
                                    <v-card dark color="secondary">
                                        <v-card-text class="px-0">
                                            <input @keyup="updateInput($event, 'input4')" maxlength="1"
                                                   v-model="input3" ref="input3"
                                                   type="text" pattern="[0-9]*" inputmode="numeric"
                                                   min="0" max="9"
                                                   @focusin="input3 = ''; input2 === '' ? moveInputToPrevious('input2') : null"
                                            >
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs1>
                                    <v-card dark color="secondary">
                                        <v-card-text class="px-0">
                                            <input @keyup="updateInput" maxlength="1" v-model="input4" ref="input4"
                                                   type="text" pattern="[0-9]*" inputmode="numeric"
                                                   min="0" max="9"
                                                   @focusin="input4 = ''; input3 === '' ? moveInputToPrevious('input3') : null"
                                            >
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="confirmDialog = false">Annuler</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import {mapActions, mapState, mapMutations} from 'vuex'
    import {getTranslationString} from "../../helper";
    import PatientGeneralInfosModal from "./modal/PatientGeneralInfosModal";
    import TreatmentCloseForm from "./modal/TreatmentCloseForm";
    import CaseCloseForm from "./modal/CaseCloseForm";
    import TreatmentResumeForm from "./modal/TreatmentResumeForm.vue";

    export default {
        name: "UserView",
        components: {
            'patient-general-infos-modal' : PatientGeneralInfosModal,
            'treatment-close-form' : TreatmentCloseForm,
            'treatment-resume-form' : TreatmentResumeForm,
            'case-close-form' : CaseCloseForm
        },
        computed: {
            ...mapState({
                locked: state => state.locked
            }),
            ...mapState(
                'patients',
                {
                    selectedPatient: state => state.selectedPatient,
                    age:
                        state => state.selectedPatient.birth_date ?
                            (Math.floor((new Date() - new Date(state.selectedPatient.birth_date).getTime()) / 3.15576e+10))
                            : ''
                }
            ),
            ...mapState('medical_cases', {
                selectedMedicalCase: state => state.selectedMedicalCase,
            }),
            ...mapState('treatments', {
                selectedTreatment: state => state.selectedTreatment,
            })
        },
        data() {
            return {
                dialog: false,
                deleteDialog: false,
                dialog_case: false,
                dialog_treatment: false,
                dialog_patient: false,
                confirmDialog: false,
                input1: '',
                input2: '',
                input3: '',
                input4: '',
                nb_try: 0,
            }
        },
        created() {
            this.setSelectedPatientId(this.$route.params.id)
            this.getPatientInfo()
        },
        methods: {
            back() {
                this.$router.back()
            },
            ...mapActions(["validateUnlock"]),
            ...mapActions('patients', [
                'getPatientInfo',
                'postDeletePatient'
            ]),
            ...mapMutations('patients', [
                'setSelectedPatientId'
            ]),
            getText(key) {
                return getTranslationString(key)
            },
            editPatient(locked) {
                this.dialog = false;
                this.$router.push({
                    name: 'patient.edit', params: {
                        locked: locked
                    }
                })
            },

            deletePatient() {
                this.deleteDialog = false;
                this.confirmDialog = true;
                this.$refs['input1'].focus();
            },

            moveInputToPrevious(ref) {
                this.$refs[ref].focus()
            },
            updateInput(event, next) {
                if (next) {
                    this.$refs[next].focus()
                } else {
                    this.validateUnlock({code: "" + this.input1 + this.input2 + this.input3 + this.input4}).then(response => {
                        this.confirmDialog = false;
                        this.nb_try = 0;

                        this.postDeletePatient(this.selectedPatient).then(response => {
                                this.input1 = ''
                                this.input2 = ''
                                this.input3 = ''
                                this.input4 = ''

                                this.$router.replace({name: 'home'})
                            }
                        ).catch(reason => {
                            this.input1 = ''
                            this.input2 = ''
                            this.input3 = ''
                            this.input4 = ''
                        })

                        //Move back to the user list
                        /*if (this.goBack != null) {
                            this.$router.replace({ path: this.goBack })
                            this.setLockedBack(null)
                        } else {
                            if (this.selectedPatient.id !== undefined) {
                                this.$router.replace({name: 'patient.view', params: {id: this.selectedPatient.id}})
                            } else {
                                this.$router.replace({name: 'home'})
                            }
                        }*/

                    }).catch(reason => {
                        this.input1 = ''
                        this.input2 = ''
                        this.input3 = ''
                        this.input4 = ''

                        this.$refs.input1.focus()
                        this.nb_try++

                        if (this.nb_try > 2) {
                            this.confirmDialog = false;
                            this.nb_try = 0;
                        }
                    })
                }
            },
        }
    }
</script>

